import React, { Component } from 'react';
import { Link } from "react-router-dom";

import config from './../config';
import EntryView from './EntryView';

class SearchResultsList extends Component {
	constructor(props) {
		super(props);

		this.url = config.apiRoot+'/api/fraedimenn/';

		this.prevPageClickHandler = this.prevPageClickHandler.bind(this);
		this.nextPageClickHandler = this.nextPageClickHandler.bind(this);

		this.state = {
			listData: []
		};
	}

	componentDidMount() {
		this.fetchData();
	}

	componentDidUpdate(prevProps, prevState) {
		if (
			prevProps.match.params.searchString != this.props.match.params.searchString
		) {
			this.fetchData();
		}
	}

	fetchData(url) {
		window.scrollTo(0, 0);

		this.setState({
			searchString: this.props.match.params.searchString
		});

		let urlParams = [];
		if (this.props.match.params.searchString) {
			urlParams.push('search='+this.props.match.params.searchString);
		}

		fetch(url || this.url+'?'+urlParams.join('&'))
			.then(function(response) {
				return response.json();
			})
			.then(function(json) {
				this.setState({
					listData: json.results,
					resultsCount: json.count,
					prevUrl: json.previous || null,
					nextUrl: json.next || null
				})
			}.bind(this));

		if (this.props.onSearch) {
			this.props.onSearch(this.props.match.params);
		}
	}

	prevPageClickHandler(event) {
		event.preventDefault();

		this.fetchData(this.state.prevUrl);
	}

	nextPageClickHandler(event) {
		event.preventDefault();

		this.fetchData(this.state.nextUrl);
	}

	render() {
		let paginationUrl = '/greinar/'+
			(this.props.match.params.searchString ? this.props.match.params.searchString : '')+
			(this.props.match.params.flokkur ? '/flokkur/'+this.props.match.params.flokkur : '')+
			(this.props.match.params.undirflokkur ? '/undirflokkur/'+this.props.match.params.undirflokkur : '')
		;

		let paginationLinks = <React.Fragment>
			{
				this.state.prevUrl &&
				<div className="page-item">
					<Link className="page-link" to={paginationUrl+(this.props.match.params.page ? '/sida/'+(parseInt(this.props.match.params.page)-1) : '')} aria-label="Previous">
						<span aria-hidden="true">&laquo; Fyrri síða</span>
						<span className="sr-only">Fyrri síða</span>
					</Link>
				</div>
			}
			{
				this.state.nextUrl &&
				<div className="page-item">
					<Link className="page-link"  to={paginationUrl+(this.props.match.params.page ? '/sida/'+(parseInt(this.props.match.params.page)+1) : '/sida/2')} aria-label="Next">
						<span aria-hidden="true">Næsta síða &raquo;</span>
						<span className="sr-only">Næsta síða</span>
					</Link>
				</div>
			}
		</React.Fragment>;

		return (
			<div className="c-field--type-text-with-summary">

				{
					this.state.listData.length > 0 &&
					<div className="pagination mb-2">
						{
							(this.state.prevUrl || this.state.nextUrl) &&
							paginationLinks
						}
					</div>
				}

				{
					this.state.listData.length ?
					this.state.listData.map(function(item, index) {
						return <React.Fragment key={index}>
							<EntryView data={item} />
						</React.Fragment>;
					})
					:
					this.state.fetching ?
					<div>
						<h4>
							<span>Leita í fræðimannaskrá</span>
						</h4>
					</div>
					:
					<li className="list-group-item">
						{this.props.match.params.searchString ? 'Leitarorðið „'+this.props.match.params.searchString+'“ skilaði engum niðurstöðum.' : 'Ekkert fannst'}
					</li>
				}

				{
					this.state.listData.length > 0 &&
					<div className="pagination">
						{
							(this.state.prevUrl || this.state.nextUrl) &&
							paginationLinks
						}
					</div>
				}

			</div>
		);
	}
}

export default SearchResultsList;
